import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../../services/mysql.service';


import { Job } from '../../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';


import { NgForm } from '@angular/forms';

import { FileUploaderService } from './../../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../../services/global-functions.service';

import { SubjectBillingItem } from '../../../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../../../shared/models/subjectInvoiceItem.model';


import { Payment } from './../../../../../shared/models/payment.model';

import { InvoicePayment } from '../../../../../shared/models/invoicePayment.model';
import { WorkOrderPayment } from './../../../../../shared/models/worOrderPayment.model';
import { Spending } from './../../../../../shared/models/spending.model';
import { SubjectBilling } from './../../../../../api/subjectBilling';
import { SubjectSpending } from './../../../../../api/subjectSpending';
import { SubjectWorkOrderItem } from './../../../../../shared/models/subjectWorkOrderItem.model';
import { SubjectWorkOrder } from './../../../../../shared/models/subjectWorkOrder.model';
import { MyobApiPurchaseSyncToolsWidgetComponent } from './../../../../../components/myob/myob-api-purchase-sync-tools-widget/myob-api-purchase-sync-tools-widget.component';
import { WorkOrdersGridComponent } from './../../../../../components/grid/work-orders-grid/work-orders-grid.component';

@Component({
  selector: 'app-subject-agent-cost-widget',
  templateUrl: './subject-agent-cost-widget.component.html',
  styleUrls: ['./subject-agent-cost-widget.component.css'],
  providers:[WorkOrdersGridComponent]
})
export class SubjectAgentCostWidgetComponent implements OnInit {

  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;

  // @Input() invoice_id?; // impliments on changes.
  // @Input() invoice_number?; // impliments on changes.

  @Input() work_order_id?; // impliments on changes.
  @Input() work_order_number?; // impliments on changes.
  
  @Input() agent_id?; // impliments on changes.

  // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent ;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full
  // @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
  @Output('refreshWorkOrderItemsBelow') refreshWorkOrderItemsBelow: EventEmitter<any> = new EventEmitter();
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;

  
  model: SubjectBilling;
  subject_billing: any;
  subject: any;
  get_latest_subject_billing_id: any;
  staticTabs: any;
  modalRef: BsModalRef;
  subject_invoices: any;
  current_invoice_couunt: number;
  subject_work_orders: any;
  current_work_order_couunt: number;
  subject_progress: any;
  invoice_status: any;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: any;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: any;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  assignedBrandList: any;

  workOrderItemsList: any = SubjectWorkOrderItem;
  paymentModel: any = Payment;
  payment: any;
  spending: any;
  spendingModel: any = Spending;

  work_order_model: any = SubjectWorkOrder;
  myob_checker: any;
  myob_response;
  subject_work_order: Object;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef,
      private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public _WorkOrdersGridComponent: WorkOrdersGridComponent,
     public agentInvoiceTools: MyobApiPurchaseSyncToolsWidgetComponent,
  ) {
 
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
 

 
   }
 
   // check for changes. to load data.
//    ngOnChanges(changes) {
 
 
//  // this.paymentModel = new Payment();  // starts a new empty payment model
//  // this.invoicePaymentModel = new InvoicePayment();  // starts a new empty payment model
 
// //  this.spendingModel = new Spending();  // starts a new empty payment model
// //  this.workOrderPaymentModel = new WorkOrderPayment();  // starts a new empty payment model
 
//     if (changes.agent_id) {
//       // deal with asynchronous Observable result
//     this.agent_id = changes.agent_id.currentValue;
//      // this.getInvoice(this.invoice_id);
//      // this.getMyobAccountCodes();

//      this.model = new SubjectBilling();
//      // this.getSubjectBilling(this.subject_id);
//      this.model.job_id = this.job_id;
//      this.model.subject_id = this.subject_id;
//      this.getJobSubject(this.subject_id);
//     // this.getSubjectInvoices(this.subject_id);
//    // this.getSubjectAgentBrandsAssigned(this.subject_id);
//      this.getSubjectAgentWorkOrders(this.subject_id, this.agent_id);
 
//     }
//   }
 



 
  ngOnInit() {
   // this.getInvoice(this.invoice_id);
   // this.getMyobAccountCodes();

         this.model = new SubjectBilling();
         // this.getSubjectBilling(this.subject_id);
         this.model.job_id = this.job_id;
         this.model.subject_id = this.subject_id;
         this.getJobSubject(this.subject_id);
        // this.getSubjectInvoices(this.subject_id);
       // this.getSubjectAgentBrandsAssigned(this.subject_id);
         this.getSubjectAgentWorkOrders(this.subject_id, this.agent_id);
           // sets up the spendingPurchase items / payments loop
            // this.getSpendingsByWorkOrderID(this.work_order_id); // This created massive erros
      //  this.myob_response = false;
      //   this.myobChecker();
  }







  getSpending(spending_id){
    this._demoService.getSpending(spending_id).subscribe(
      (data) => {
        this.spending = data;
        this.spendingModel = this.spending;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }
  
  getSpendingsByWorkOrderID(work_order_id){
    this._demoService.getSpendingByWorkOrderID(work_order_id).subscribe(
      (data) => {
        this.spending = data;
        this.spendingModel = this.spending;
        let res = data[0];
        console.log('SpendingModel: ' + JSON.stringify(this.spendingModel));
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }






  // getSubjectBilling(subject_id) {
  //   this._demoService.getSubjectBilling(subject_id).subscribe(
  //     data => { this.subject_billing = data;
  //      // console.log("Done loadng USER");
  //     },
  //     error => {
  //     //  console.error('Error Loading User!');
  //     // return Observable.throw(error);
  //     }
  //   ); }


    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
          this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }


  //   createSubjectBilling(model){
  //     this._demoService.createSubjectBilling(model).subscribe(
  //       data => {  this.get_latest_subject_billing_id = data; // this is the retuned json upon creation.
  //        this.toastr.info('Subject Billing Created');
  //        this.getSubjectBilling(this.subject_id); // refresh the data

  //        this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
  //        this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));

  //       },
  //       error => {
  //         // console.log(Observable.throw(error));
  //         // return Observable.throw(error);
  //       }
  //  );
  //  }

//    updateSubjectBilling(model){
//     this._demoService.updateSubjectBilling(model).subscribe(
//       data => { // this.trace_candidate_update = data;
//         // refresh the list
//        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
//       this.toastr.success('Subject Billing Updated');
//       this.getSubjectBilling(this.subject_id); // refresh the data
            
//                 this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
//                 this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
//       },
//       error => {
//        // console.error('Error saving Event!');
//         this.toastr.error('Error saving billing details!');
//         return Observable.throw(error);
//       }
//      // err => console.error(err),
//      // () => console.log('done updates')
//  );
//  }


  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
  };



  
 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// // :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


// // :: Parent / Child modal test
// refreshParentdGrid() {
//   alert('parent grid component function.');
//  //this.modalRef.hide();
// this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// };

refreshSujectInvoicePage(subject_id){
  this.router.navigateByUrl('admin/jobs/home', {skipLocationChange: true}).then(() =>
                this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));

}


refreshSujectWorkOrderPage(subject_id){
  // this.router.navigateByUrl('admin/jobs/home', {skipLocationChange: true}).then(() =>
  //               this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']));
                this.gfunc.globalJobSubjectCostViewSkipRoute(subject_id);

}


getSubjectInvoices(subject_id) {
  this._demoService.getSubjectInvoices(subject_id).subscribe(
     data => { this.subject_invoices = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.
   // do a count if exists
   let newArr = Object(this.subject_invoices);
   this.current_invoice_couunt = Object.keys(newArr).length;

    }, // make the same data call for all
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




 deleteWorkOrderAndSetCostItems(work_order_model){
  if (confirm('Are you sure you want to delete this Supplier Invoice in Both Myob + SOP. All items will be placed back into Supplier cost items, yet to be invoiced.')) {
 
 
 
 if (work_order_model.myob_id){
   this._WorkOrdersGridComponent.deleteMyobServiceWorkOrderModel(work_order_model);
 };

 
    // get all items and loop  
  // remove function and update subject billing items "not-invoiced"
  // end loop
console.log( 'WorkOrderID: ' + work_order_model.work_order_id);
  // this.getInvoiceItmes(invoice_model.invoice_id);
  this._demoService.getSubjectWorkOrderItems(work_order_model.work_order_id).subscribe(
    (data) => {
      this.workOrderItemsList = data;
      let res = data[0];
     // this.invoice_item_model = this.invoiceItemsList;
     console.log( JSON.stringify(this.workOrderItemsList) );
      let newArr = data;
          let  count_of_items = Object.keys(newArr).length;
          for(let i=0;i < count_of_items; i++) {
                  let res = newArr[i];
                  // console.log('Item:' + i + ' ID: ' + res.invoice_item_id);
                  this.deleteSubjectWorkOrderItem(res, res.work_order_item_id);
                  // this updates the status NOT invoice of all subject invoice itmes;
          }// end for loop
  // then remove invoice_items and invoice data rows
        this.deleteWorkOrderAndItems(work_order_model);
        this.toastr.success('Supplier Invoice Removed and Subject Cost Items used now set "Not Invoiced".');
        // Now Reload the page.
        this.gfunc.insertLog_DeleteWorkOrder(work_order_model);
        this.refreshSujectWorkOrderPage(this.subject_id);
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
    ); // end subscribe.
} // end confirm
}


deleteWorkOrderAndItems(model) {
  // if (confirm('Are you sure you want to delete this invoice and items? ')) {
    this._demoService.deleteWorkOrder(model.work_order_id).subscribe(
       data => {
       //  this.getTraceCandidateNotes(this.trace_candidate_id);
         return true;
       },
       error => {
         console.error('Error deleting Supplier Invoice!');
        return console.log(error);
       }
    );
// }
}


deleteSubjectWorkOrderItem(model, work_order_item_id){
  // tslint:disable-next-line:max-line-length
  // if (confirm('Are you sure you want to delete this item from the invoice. It will still appear in billing items, yet to be invoiced.')) {
    this._demoService.deleteSubjectWorkOrderItem(model, work_order_item_id).subscribe(
       data => {
        // update the status of subjectbillingItems
        // let work_order_status = 'NOT-INVOICED';
        let work_order_status = 'NOT-APPLIED';
        let work_order_id = model.work_order_id;
        let work_order_number = model.work_order_number;
        let subject_cost_item_id = model.subject_cost_item_id;
        this.updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number);
        // refresh the list
       // tslint:disable-next-line:max-line-length
       ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
        // refresh the bottom widow of sibjectBillingItems from Modal
        // this.refreshSujectInvoicePage(this.subject_id);
        /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.
        // this.getInvoiceItmes(this.invoice_id);
         return true;
       },
       error => {
         console.error('Error deleting Work Order Items Data!');
         console.error(error);
         // return Observable.throw(error);
       }
    );
// }
}





updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number){
  // tslint:disable-next-line:max-line-length
  this._demoService.updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }


 updateWorkOrderStatus(work_order_model){
  work_order_model.work_order_status_id = 3; // approved
  this._demoService.updateWorkOrderStatus(work_order_model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the invoice:
      this.gfunc.insertLog_UpdateWorkOrder(work_order_model);
      // refresh the page

      this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
    },
    error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Changing Status of Work Order');
      return console.error(error);
    }
   // err => console.error(err),
   //
  )};



 getSubjectAgentWorkOrders(subject_id, agent_id) {
  this._demoService.getSubjectAgentWorkOrders(subject_id, agent_id).subscribe(
     data => { this.subject_work_orders = data;
   let res = data[0];
  // this.subject_invoices = res; // only return the first result and save back the the same variable.

  // sets up the spending loop here
  // this.getSpendingsByWorkOrderID(res.work_order_id); // This created massive erros

   // do a count if exists
   let newArr = Object(this.subject_work_orders);
   this.current_work_order_couunt = Object.keys(newArr).length;
  //  this.agent_id = newArr[0].agent_id;

    }, // make the same data call for all
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getSubjectProgress(job_id, file_number){
  this._demoService. getSubjectProgress(job_id, file_number)
  .subscribe(
    res => this.subject_progress = res,
    err => console.error(err.status)
  );
 }





 getInvoiceStatus(invoice_status_id){
  this._demoService.getInvoiceStatus(invoice_status_id).subscribe(
    (data) => {
      this.invoice_status = data;
      let res = data[0];
      this.invoice_status_name = res.invoice_status_name;
      this.invoice_status_var = invoice_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



getInvoicePaymentStatus(invoice_payment_status_id){
  this._demoService.getInvoicePaymentStatus(invoice_payment_status_id).subscribe(
    (data) => {
      this.invoice_payment_status = data;
      let res = data[0];
      this.invoice_payment_status_name = res.invoice_payment_status_name;
      this.invoice_payment_status_var = invoice_payment_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatus(invoice_communication_status_id){
  this._demoService.getInvoiceCommunicationStatus(invoice_communication_status_id).subscribe(
    (data) => {
      this.invoice_communication_status = data;
      let res = data[0];
      this.invoice_communication_status_name = res.invoice_communication_status_name;
      this.invoice_communication_status_var = invoice_communication_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
    (data) => {
      this.assignedBrandList = data;

    //  this.allEmailRecipients = data;
    },
    (err) => console.error(err),
    // () => console.log('Loaded Assigned Agents Loaded.')
  );
}


myobChecker() {
  this._demoService.myobChecker().subscribe(
     data => { this.myob_checker = data;
      let res = data[0];
      // this.toastr.success('Myob Connections Active!... functions allowed');
// console.log('Connected: ', JSON.stringify(this.myob_checker));
this.myob_response = true;
    },
     err => (
      // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
      this.myob_response = false,
      console.error(err)
     ),
     // () => console.log('done loading Trace Types')
   );
 }



 // Do some delays....  and see what happends abit 2 secpmds betwen each...

 approveAndPushWorkOrder(work_order_model){

  // this.updateInvoiceStatus(invoice_model);
  // this.createSubjectInvoicePDF(invoice_model, invoice_model.invoice_id)

  this.toastr.info("Approving.")
  //  this.createSubjectInvoicePDFAndSend(invoice_model, invoice_model.invoice_id);
  this.updateWorkOrderStatus(work_order_model)

  setTimeout(() => {  
    this.toastr.info("Gathering updated invoice datas, ready for Sync")
    // this.getInvoice(invoice_model.invoice_id, invoice_model)
    // get the work order -- and then sycn the work order in that module from the components exactly the same as invoice. just skip the send.... so can be  a little quicker
    this.getSubjectWorkOrder(work_order_model.work_order_id)
    }, 2500);
  /// Mow Sync the invoice with MYOB. -- link to function through components 

  // setTimeout(() => {  

  //   // Need to lookup invoice status

  //     // Set the same model as above so that the correct invoice details

  //   this.toastr.info("Starting Sync")
  //   // invoice_model = this.invoiceItem // set to updated invoice item above.
 
  
  //   }, 6000);
  


}

getSubjectWorkOrder(work_order_id){
  this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
    data => {
      this.subject_work_order = data;
  // let res = data[0];
  // this.current_work_order_UID = res.UID;
  // this.current_work_order_UID = res.UID;


  this.agentInvoiceTools.setMyobWorkOrderModelStep1(data[0]);

     },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



}
